import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import P2 from '@base/P2/P2';
import H6 from '@base/H6/H6';
import Button from '@base/Button/Button';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import pushRoute from '@utils/pushRoute';
import { Spacings } from '@styles/index';
import LeftIcon from './LeftIcon';

const Wrapper = styled.div`
  grid-column: 9/25;
  padding: ${Spacings.SPACING_6B};
  padding-right: ${Spacings.SPACING_12B};
  background-color: var(--color-base-1);
  border-radius: ${Spacings.SPACING_2B};
  margin-bottom: ${Spacings.SPACING_4B};
  box-shadow: ${boxShadowGenerator()};
  display: flex;
  justify-content: space-between;
  @media (max-width: 47.95em) {
    flex-wrap: wrap;
    padding: 16px;
  }
`;

const Cover = styled.div`
  display: flex;
  @media (max-width: 47.95em) {
    margin-bottom: 16px;
  }
`;

const Info = styled.div`
  width: 464px;
  @media (max-width: 47.95em) {
    width: 100%;
    flex: 1;
  }
`;

const StyledButton = styled(Button)`
  @media (max-width: 47.95em) {
    flex: 1;
  }
`;

const Copy = styled(P2)`
  margin-top: ${Spacings.SPACING_2B};
`;

const ExtendSubscription = ({ subscription, className }) => {
  const handleClick = () => {
    const relativeLink = subscription?.subscription?.value?.relative_link;
    if (relativeLink)
      pushRoute(
        '/goal/[goalSlug]/[goalUID]/subscribe',
        `${relativeLink}/subscribe`
      );
  };

  return (
    <Wrapper className={className}>
      <Cover>
        <LeftIcon lesson={{ liveAt: subscription.expired_at }} showDate />
        <Info>
          <H6 color="var(--color-text-primary)">
            {`Your ${
              subscription?.subscription?.type === 1
                ? 'subscription'
                : 'free trial'
            } ends on this day`}
          </H6>
          <Copy color="var(--color-text-secondary)">
            {`${
              subscription?.subscription?.type === 1 ? 'Renew' : 'Buy'
            } your subscription to access sessions after this date`}
          </Copy>
        </Info>
      </Cover>
      <StyledButton
        label={subscription?.subscription?.type === 1 ? 'Renew' : 'Buy'}
        grid={2}
        onClick={handleClick}
      />
    </Wrapper>
  );
};

export default ExtendSubscription;

ExtendSubscription.propTypes = {
  subscription: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string
};

ExtendSubscription.defaultProps = {
  subscription: null,
  className: ''
};
